import styled, { css } from 'styled-components';
import { Box, ModalHeader, ModalBody, ModalSubHeaderStyled } from '@bechtel/gds';

export const CommodityMilestoneStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};

  ${({ theme }) => css`
    padding: ${theme.spacings[450]} ${theme.spacings[500]};
  `}
`;

export const ModalSubHeader = styled(ModalSubHeaderStyled)`
  ${({ theme }) => css`
    padding: ${theme.spacings[550]} ${theme.spacings[500]};
  `}
`;

export const ModalHeaderStyled = styled(ModalHeader)`
  ${({ theme }) => css`
    min-width: ${theme.breakpoints.mobile};
    background: ${theme.colors.bechtel.blue[800]};
  `}

  h1 {
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights[600]};
  }
  button {
    background: none;
    color: ${({ theme }) => theme.colors.white};
    &:hover {
      background-color: ${({ theme }) => theme.colors.bechtel.blue[800]};
    }
  }
`;

export const ModalBodyStyled = styled(ModalBody)`
  flex-direction: column;
`;

export const ModalSubFooter = styled(Box).attrs({ p: { sm: '500' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.bechtel.blue[100]};
    border-top: 1px solid ${theme.colors.grey[300]};
  `}
`;
